import React from 'react'
import { DebounceInput } from 'react-debounce-input'
import './index.css'
import { SearchIcon } from 'assets'
function DebounceInputBox({ placeholder, onSearch, className, value }) {
   return (
      <div className="">
         <div className="serach-input-box-wrap">
            <SearchIcon />

            <DebounceInput
               value={value}
               type="text"
               className={`form-control serach-input-box ${className}`}
               placeholder={placeholder}
               debounceTimeout={300}
               onChange={(e) => onSearch(e.target.value)}
               minLength={2}
            />
         </div>
      </div>
   )
}

export default DebounceInputBox
